var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: ["lf-schedule", { sync: _vm.calendarProvider }] },
    [
      _vm.showGeneralSpinner
        ? _c("SpinnerLayerComponent", { staticClass: "general-spinner" })
        : _vm._e(),
      _vm.calendarProvider
        ? [
            _c("span", { class: [_vm.icons.info, "info-icon", "lf-icon__md"] }),
            _vm.calendarProvider
              ? _c("div", { staticClass: "lf-schedule-text" }, [
                  _c("span", { staticClass: "lf-schedule-title" }, [
                    _vm._v(_vm._s(_vm.texts.calendars)),
                  ]),
                  _c("span", { staticClass: "lf-calendar-description" }, [
                    _vm._v(" " + _vm._s(_vm.texts.description)),
                  ]),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.hasAppointment &&
                            _vm.showNewButton &&
                            _vm.calendarProvider,
                          expression:
                            "!hasAppointment && showNewButton && calendarProvider",
                        },
                      ],
                      staticClass: "lf-calendar-link",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onCreateEvent.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.texts.newEvent))]
                  ),
                ])
              : _vm._e(),
          ]
        : [
            _c("span", {
              class: [_vm.icons.warning, "warning-icon", "lf-icon__md"],
            }),
            _c("div", { staticClass: "lf-schedule-text" }, [
              _c("span", { staticClass: "lf-schedule-title" }, [
                _vm._v(_vm._s(_vm.texts.calendarSync)),
              ]),
              _c("span", { staticClass: "lf-calendar-description" }, [
                _vm._v(_vm._s(_vm.texts.calendarSyncText)),
              ]),
              _c("div", { staticClass: "lf-schedule-links" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.hasAppointment && !_vm.calendarProvider,
                        expression: "!hasAppointment && !calendarProvider",
                      },
                    ],
                    staticClass: "lf-calendar-link",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.selectCalendarProvider.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.texts.configAccount))]
                ),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.showRefresh &&
                          !_vm.hasAppointment &&
                          !_vm.calendarProvider,
                        expression:
                          "showRefresh && !hasAppointment && !calendarProvider",
                      },
                    ],
                    staticClass: "lf-calendar-link",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.refreshScreen.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.texts.refreshScreen))]
                ),
              ]),
            ]),
          ],
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasAppointment,
              expression: "hasAppointment",
            },
          ],
          staticClass: "lf-schedule-event-info",
        },
        [
          _c(
            "div",
            {
              staticClass: "lf-schedule-event-info-header",
              style: { backgroundColor: _vm.appointment.color },
            },
            [_vm._v(_vm._s(_vm.appointment.subject))]
          ),
          _c(
            "div",
            {
              staticClass: "lf-schedule-event-info-content",
              style: { borderColor: _vm.appointment.color },
            },
            [
              _c("div", { staticClass: "lf-schedule-event-col" }, [
                _c("span", { class: [_vm.icons.calendarCheck, "lf-sch-icon"] }),
                _c("span", [_vm._v(_vm._s(_vm.appointment.startDate))]),
              ]),
              _c("div", { staticClass: "lf-schedule-event-col" }, [
                _c("span", { class: [_vm.icons.meeting, "lf-sch-icon"] }),
                _c("span", [_vm._v(_vm._s(_vm.appointment.calendarName))]),
              ]),
              _vm.appointment.typeEvent
                ? _c("div", { staticClass: "lf-schedule-event-col" }, [
                    _c("span", {
                      class: [_vm.icons.circle, "lf-sch-icon"],
                      style: { color: _vm.appointment.typeEventColor },
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.appointment.typeEvent))]),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "lf-schedule-event-col lf-action-text" },
                [
                  _c("span", { class: [_vm.icons.visible, "lf-sch-icon"] }),
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.editEvent()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.texts.moreDetails))]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm.showDialog
        ? _c(
            "div",
            {
              staticClass: "dialog-container",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.checkIfHideDialog.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialog-message-container" },
                [
                  _c("LfBlueTitleComponent", {
                    staticClass: "blue-title",
                    attrs: { title: _vm.labelDialog, showClose: "" },
                    on: { close: _vm.hideDialog },
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showSpinner,
                          expression: "showSpinner",
                        },
                      ],
                      staticClass: "lf-dialog-spinner",
                    },
                    [
                      _c("SpinnerLayerComponent", {
                        staticClass: "spinner-layer",
                      }),
                    ],
                    1
                  ),
                  _c("iframe", {
                    attrs: {
                      src: _vm.url,
                      frameborder: "0",
                      allowfullscreen: "",
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }